import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ModalContainer from '@molecules/ModalContainer/ModalContainer';
import BackgroundJobWait from '@molecules/BackgroundJobWait/BackgroundJobWait';
import { backgroundJobModalProps } from '@molecules/BackgroundJobWait/backgroundJobWaitModal';
import { useBackgroundJobRun } from '@molecules/BackgroundJobWait/useBackgroundJobRun';
import { BackgroundJobTask } from '@services/backgroundJobs/backgroundJobTask';
import { ATTACHMENTS_ARCHIVE_KIND } from './attachmentsArchiveTask';

const SUBJECT = 'Собираем архив';

export interface IAttachmentsArchiveModalProps {
    /** Заголовок окна — название действия. */
    header: string;
    /** Сборка архива (`createAttachmentsArchiveTask`); окно запускает её сразу. */
    task: BackgroundJobTask;
    onClose: () => void;
}

/**
 * Окно сборки архива вложений: формы нет — с открытия лоадер с этапом и счётом файлов, «Продолжить в фоне», итог
 * «Архив готов» с «Скачать архив» по кнопке (без автоскачивания) или причина отказа.
 */
const AttachmentsArchiveModal = ({ header, task, onClose }: IAttachmentsArchiveModalProps) => {
    const formMethods = useForm();
    const job = useBackgroundJobRun({ kind: ATTACHMENTS_ARCHIVE_KIND });
    const { phase, result, startTask } = job;

    useEffect(() => {
        startTask(task);
    }, [startTask, task]);

    const stagePhase = phase === 'idle' || phase === 'leaving' ? 'loading' : phase;
    const finished = phase === 'result' && !!result;
    const succeeded = finished && result.tone === 'ok';

    return (
        <ModalContainer
            header={header}
            size="m"
            {...backgroundJobModalProps(job, { title: header, close: onClose, cancelButtonText: 'Закрыть' })}
            formMethods={formMethods}
            showOkButton={succeeded}
            okButtonText="Готово"
            showCancelButton={!succeeded}
            hasUnsavedInput={() => false}
            onSubmit={onClose}
        >
            <BackgroundJobWait
                ref={job.waitRef}
                kind={ATTACHMENTS_ARCHIVE_KIND}
                phase={stagePhase}
                subject={SUBJECT}
                stageText={job.stage}
                stageName={job.stageName}
                background={job.background}
                result={result}
                onDownload={job.downloadResultFile}
                downloading={job.downloadingResultFile}
            />
        </ModalContainer>
    );
};

export default AttachmentsArchiveModal;
